// Date-of-birth check before checkout. Markup: snippets/hbc-age-check.liquid.
// Stops checkout until the buyer's date of birth makes them 20 or over,
// and saves the date to the cart so it reaches the order and survives the drawer re-rendering.
if (!customElements.get('hbc-age-check')) {
  customElements.define(
    'hbc-age-check',
    class HbcAgeCheck extends HTMLElement {
      connectedCallback() {
        this.y = this.querySelector('[data-part="y"]');
        this.m = this.querySelector('[data-part="m"]');
        this.d = this.querySelector('[data-part="d"]');
        this.ageOut = this.querySelector('[data-part="age"]');
        this.under = this.querySelector('[data-part="under"]');
        this.hint = this.querySelector('[data-part="hint"]');
        this.addEventListener('change', () => this.update(true));
        this.update(false);
      }

      // Returns { iso, age } for a real calendar date, or null.
      birth() {
        const y = parseInt(this.y.value, 10);
        const m = parseInt(this.m.value, 10);
        const d = parseInt(this.d.value, 10);
        if (!y || !m || !d) return null;
        const date = new Date(y, m - 1, d);
        if (date.getMonth() !== m - 1) return null; // e.g. 31 February
        const today = new Date();
        let age = today.getFullYear() - y;
        if (today.getMonth() < m - 1 || (today.getMonth() === m - 1 && today.getDate() < d)) age -= 1;
        if (age < 0) return null;
        const pad = (n) => String(n).padStart(2, '0');
        return { iso: `${y}-${pad(m)}-${pad(d)}`, age };
      }

      isOk() {
        const b = this.birth();
        return b !== null && b.age >= 20;
      }

      update(save) {
        const b = this.birth();
        const ok = b !== null && b.age >= 20;
        this.ageOut.textContent = b ? b.age : '  ';
        this.under.hidden = !(b && b.age < 20);
        this.hint.hidden = true;
        this.classList.toggle('is-ok', ok);
        if (save && ok) {
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 生年月日: b.iso, 年齢: String(b.age) } }),
          });
        }
      }

      showHint() {
        if (this.under.hidden) this.hint.hidden = false;
        this.querySelector('select').focus();
      }
    }
  );

  // The button is left enabled (Dawn re-renders and re-enables it as the cart changes), so a
  // checkout without a valid date of birth is stopped here and the box says why.
  const blockCheckout = (event, button) => {
    if (!button || button.name !== 'checkout') return;
    const check = document.querySelector(`hbc-age-check[data-button="${button.id}"]`);
    if (check && !check.isOk()) {
      event.preventDefault();
      event.stopPropagation();
      check.showHint();
    }
  };
  document.addEventListener('click', (event) => blockCheckout(event, event.target.closest('button')), true);
  document.addEventListener('submit', (event) => blockCheckout(event, event.submitter), true);
}
